// extracted by mini-css-extract-plugin
export default {"quizCard":"styles_quizCard__kfMdv","quizAnswers":"styles_quizAnswers__doEYi"};